import React from "react";
import ProjectLists from "../DashboardProject/ProjectLists";
import { ProjectStatuses } from "../../constants/Status";


const ApprovedProjectListDashboard = () => {
  // document.title = "Approved-Projects";
  // document.title="Vector Maps | Velzon - React Admin & Dashboard Template";
  return (
    <div className="page-content">
      <div className="container-fluid">
        <ProjectLists status={[ProjectStatuses.ONGOING, ProjectStatuses.SENT_FOR_CONFIRMATION, ProjectStatuses.CONFIRMATION_REJECTED]} />
      </div>
    </div>
  );
};

export default ApprovedProjectListDashboard;
